import(/* webpackMode: "eager" */ "/workspace/scratch/57173327f5eb/bitsukuk-main/src/app/login/page.tsx");
